<app-notification-pwa-install></app-notification-pwa-install>
<app-notification-pwa-update></app-notification-pwa-update>
<app-notification-pwa-offline></app-notification-pwa-offline>
<router-outlet></router-outlet>